import { usePost } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useAddProject = () => {
  return usePost({ url: ApiRoutesEnum.addProject });
};
